import React from 'react';
import { LoanBuilder } from './index';
import { FormValues } from '../../../types';

interface BuilderContainerProps {
  values: FormValues;
  setValues: (updates: Partial<FormValues>) => void;
  setValue: (key: string, value: string | number) => void;
  onSelectLoanOption: (option: any) => void;
  isBrokerMode: boolean;
  isProcessingTeamMode: boolean;
}

export const BuilderContainer: React.FC<BuilderContainerProps> = ({
  values,
  setValues,
  setValue,
  onSelectLoanOption,
  isBrokerMode,
  isProcessingTeamMode,
}) => {
  return (
    <LoanBuilder
      values={values}
      setValues={setValues}
      setValue={setValue}
      onSelect={onSelectLoanOption}
      isBrokerMode={isBrokerMode}
      isProcessingTeamMode={isProcessingTeamMode}
    />
  );
};

